import React from 'react';
import useStyle from './tooManyLoginBlock.style';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { classNames } from 'helpers/style/classNames';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';

export const TooManyLoginBlock = ({
  buttonClick
}: {
  buttonClick?: () => void;
}) => {
  const classes = useStyle();

  return (
    <ContainerFullWidth>
      <div className={classes.block}>
        <p className={classes.title}>
          Pour vous connecter, vous devez saisir les informations communiquées
          par votre professeur(e){' '}
          <span role="img" aria-label="professeur">
            🧑‍🏫
          </span>
        </p>
      </div>
      <div className={classes.listdiv}>
        <p className={classes.title}>
          - IDENTIFIANT : nom d’utilisateur (ex: “jules5043”) / adresse e-mail
          (e-mail de PREMIERE connexion finissant par
          @changez-pour-votre-mail.monmail)
        </p>
        <p className={classes.title}>- MOT DE PASSE</p>
      </div>
      <div className={classNames([classes.block, classes.withImg])}>
        <p className={classes.desc}>
          Si votre professeur(e) ne vous a pas communiqué ces informations,{' '}
          <span className={classes.bold}>
            vous ne pouvez pas vous connecter à l’application !
          </span>{' '}
          Merci de les lui demander.
        </p>
      </div>
      <p className={classes.title}>
        Je n'arrive pas à me connecter malgré-tout ?
      </p>
      <ButtonWithText
        content="Réinitialiser le mot de passe"
        onClick={buttonClick}
      />
      <p className={classes.title}>
        Le problème persiste après renouvellement du mot de passe ?
      </p>
      <div className={classNames([classes.block, classes.withImg])}>
        <p className={classes.desc}>
          <span className={classes.bold}>
            Contactez-nous via notre formulaire de contact avec le lien
            ci-dessous
          </span>{' '}
          en précisant :<br />
          -nom d’utilisateur | -e-mail | -heure et jour de connexion | -le
          message d’erreur indiqué sur l’application
        </p>
      </div>
    </ContainerFullWidth>
  );
};
